import {Component, ComponentFactoryResolver, HostBinding, OnInit, ViewChild} from '@angular/core';
import {filter} from 'rxjs/operators';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {SideItemDirective} from '../../side-item.directive';
import {SideService} from '../../services/side.service';
import {KeyboardService} from '../../services/keyboard.service';

@Component({
  selector: 'app-side',
  templateUrl: './side.component.html',
  styleUrls: ['./side.component.scss'],
  animations: [
    trigger('transform', [
      state('open', style({
        'transform': 'none',
        'visibility': 'visible',
      })),
      state('void', style({
        'box-shadow': 'none',
        'visibility': 'hidden',
      })),
      transition('void <=> open',
        animate('400ms cubic-bezier(0.25, 0.8, 0.25, 1)'))
    ])
  ]
})
export class SideComponent implements OnInit {

  @HostBinding('@transform')
    // tslint:disable-next-line:variable-name
  _animationState: 'open' | 'void' = 'void';


  @ViewChild(SideItemDirective, {static: true}) sideItem: SideItemDirective;

  private keyUpSubscription;
  public componentRef;

  constructor(private sideService: SideService,
              private componentFactoryResolver: ComponentFactoryResolver) {
  }


  ngOnInit() {

    this.sideService.activeComponent$
      .subscribe(
        (component) => {

          this.sideItem.viewContainerRef.clear();

          if (!component) {

            if (this.keyUpSubscription) {
              this.keyUpSubscription.unsubscribe();
            }
            this._animationState = 'void';

            return;
          }

          this._animationState = 'open';
          const componentFactory = this.componentFactoryResolver.resolveComponentFactory(component);
          this.componentRef = this.sideItem.viewContainerRef.createComponent(componentFactory);
        }
      );
  }

  close(): void {
    this.sideService.close();
    this.sideService.closed$.next(true);
  }

}
